import { Injectable } from "@angular/core";
import { IRule, IRuleListInfo } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "../shared/api/api.service";
import { BaseApiService } from "../shared/api/baseApi.service";

/**
 * Access to the rules routes of the configurator server (see @comunicare/rules-router).
 */
@Injectable({
  providedIn: "root",
})
export class RulesApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Rules", // Theme !
      ["dashboard/rules"], // Post route paths
      [
        "dashboard/rules", // 0
        "dashboard/rulesInfos", // 1
        "dashboard/rulesInfos/count", // 2
      ], // Get route paths
      ["dashboard/rules"], // Update route paths
      ["dashboard/rules"] // Delete route paths
    );
  }

  public getRule(identifier: string): Observable<IRule> {
    return this.api.get(this.readRoutes[0], { identifier }) as Observable<IRule>;
  }

  public createRule(rule: IRule): Observable<IRule> {
    return this.api.post(this.createRoutes[0], rule) as Observable<IRule>;
  }

  public updateRule(rule: IRule): Observable<IRule> {
    return this.api.put(this.updateRoutes[0], rule) as Observable<IRule>;
  }

  public deleteRule(identifier: string): Observable<boolean> {
    return this.api.delete(this.deleteRoutes[0], { identifier }) as Observable<boolean>;
  }

  public getRulesInfos(
    pageNumber?: number,
    pageSize?: number,
    search?: string,
    sortId?: string,
    sortOrder?: string,
    filters?: string,
    language?: string
  ): Observable<IRuleListInfo[]> {
    const params = { pageNumber, pageSize, search, sortId, sortOrder, filters, language };
    return this.api.get(this.readRoutes[1], params) as Observable<IRuleListInfo[]>;
  }

  public getRulesInfosCount(search?: string, filters?: string): Observable<{ count: number }> {
    const params = { search, filters };
    return this.api.get(this.readRoutes[2], params) as Observable<{ count: number }>;
  }
}
